export const albums = [
    {
        id: "0",
        title: "Whole Lotta Red",
        artist: "Playboi Carti",
        description: "Whole Lotta Red is the second studio album by American rapper Playboi Carti. It was released on December 25, 2020, by Interscope Records as well as ASAP Rocky's AWGE label.",
        rating: 5,
        image: "wlr.png",
    },
    {
        id: "1",
        title: "Die Lit",
        artist: "Playboi Carti",
        description: "Die Lit is Playboi Carti's debut studio album and a follow-up to his eponymous debut mixtape. The album is executively produced by Pi'erre Bourne and boasts features from Young Thug, Lil Uzi Vert, Travis Scott, Nicki Minaj, and Skepta, among many others.",
        rating: 5,
        image: "die_lit.jpg",
    },
    {
        id: "2",
        title: "Warlord",
        artist: "Yung Lean",
        description: "Warlord is the second studio album by Swedish rapper Yung Lean. It was released on February 25, 2016, by YEAR0001. It was recorded from the spring to the fall of 2015, across Florida and Stockholm.",
        rating: 5,
        image: "warlord.jpg",
    },
    {
        id: "3",
        title: "Unknown Memory",
        artist: "Yung Lean",
        description: "Unknown Memory is the debut studio album by Swedish rapper Yung Lean following his critically acclaimed mixtape Unknown Death 2002 and his Lavender EP, released on September 23, 2014.",
        rating: 5,
        image: "u_m.jpg",
    },
    {
        id: "4",
        title: "BALLADS 1",
        artist: "Joji",
        description: "Ballads 1 is the debut studio album by Japanese singer-songwriter Joji. It serves as a follow-up to In Tongues EP, his first project as Joji, and Pink Season, his only album released under the now-retired alter-ego Pink Guy.",
        rating: 4,
        image: "ballads1.png",
    },
    {
        id: "5",
        title: "Nectar",
        artist: "Joji",
        description: 'Nectar is the second studio album by Japanese singer-songwriter Joji, released on 25 September 2020 via 88rising. It features the singles "Sanctuary", "Run", "Gimme Love", "Daylight" with Diplo, and "Your Man", as well as collaborations with Benee, Lil Yachty, Omar Apollo, Yves Tumor and Rei Brown.',
        rating: 4,
        image: "nectar.png",
    },
    {
        id: "6",
        title: "Up 2 Më",
        artist: "Yeat",
        description: "Up 2 Më is the debut studio album by American rapper Yeat. It was released on September 10, 2021 through Interscope Records and Twizzy Rich. The album's lead single, Gët Busy, was released on September 1, 2021, just nine days before the album.",
        rating: 3,
        image: "up2me.png",
    },
    {
        id: "7",
        title: "17",
        artist: "XXXTENTACION",
        description: "This album was first announced on X's Periscope when he was released on probation in March. He also addressed it in his interview with 103.5 The Beat. On July 30th, X announced the release date on his Instagram story, which was August 25th.",
        rating: 4,
        image: "17.png",
    },
    {
        id: "8",
        title: "?",
        artist: "XXXTENTACION",
        description: "Released on March 16th, 2018, ? is XXXTENTACION's second studio album. On January 28th, the cover art was revealed on X's Instagram story with the caption, “coming soon.",
        rating: 4,
        image: "questionmark.jpg",
    },
    {
        id: "9",
        title: "Bad Vibes Forever",
        artist: "XXXTENTACION",
        description: "Bad Vibes Forever is XXXTENTACION's fourth and final studio album. It's also his second album to be released posthumously, following SKINS exactly a year prior.",
        rating: 4,
        image: "bad_vibes_forever.png",
    },
    {
        id: "10",
        title: "hors d'oeuvre",
        artist: "schafter",
        description: "Najgorętsze nazwisko młodego polskiego rapu wchodzi na wyższy level - wydany jesienią 2018 w wersji cyfrowej “hors d'oeuvre” doczeka się wersji fizycznej na CD! Oficjalny debiut Schaftera ukazuje się w specjalnej oprawie graficznej przygotowanej przez Simo.",
        rating: 5,
        image: "hors.png",
    },
];